import { ComponentType, ReactNode } from "react";

import dynamic from "next/dynamic";

import { useTranslator } from "@eo-locale/react";

import ParticipantHeader from "@/components/participant-header";
import Footer from "@/components/footer";
import { Flex, SkipNavContent, SkipNavLink } from "@/storybook-components";
import useVisitsLogging from "@/hooks/useVisitsLogging";

import ImageBanner from "../../image-banner";
import { useAppSelector } from "@/redux/store/hooks";

interface EHQLayoutProps {
  children: ReactNode;
}

type LoadComponent = (path: string) => ComponentType<any>;

const EHQLayout = ({ children }: EHQLayoutProps): JSX.Element => {
  useVisitsLogging();
  const { translate } = useTranslator();
  const { features } = useAppSelector((state) => state.features);
  const { nonce } = useAppSelector((state) => state.adapter.adapter);
  const isNewCookieConsentEnabled = features?.newCookieConsentManager?.enabled;

  const loadComponent: LoadComponent = (path) =>
    dynamic(() => import(`../../../../../components/${path}`), { ssr: false });

  const CookieConsent = isNewCookieConsentEnabled
    ? loadComponent("enhanced-cookie-consent")
    : loadComponent("cookie-consent");

  return (
    <Flex flexDirection="column" minH="100vh">
      <CookieConsent />
      <SkipNavLink id="start-of-content" zIndex={1}>
        {translate("common.skipToContent")}
      </SkipNavLink>
      <ParticipantHeader />
      <Flex as="main" flex={1} flexDirection="column">
        <ImageBanner />
        <SkipNavContent id="start-of-content" style={null} nonce={nonce} />
        {children}
      </Flex>
      <Footer />
    </Flex>
  );
};

export default EHQLayout;
